export default __webpack_public_path__ + "static/media/money-mouth-face.4a48daf1.png";